import React, { useEffect, useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import axios from "axios";

let { lambda } = window.app; // Assuming lambda URL is globally available

const SwaggerComponent = () => {
    const [swaggerData, setSwaggerData] = useState(null);

    useEffect(() => {
        axios.get(`https://78slaf6rkh.execute-api.us-east-1.amazonaws.com/latest/swaggerData?appname=spotsaverDev`)
            .then(response => {
                console.log("Swagger response:", response);

                if (response?.data?.result) {
                    let modifiedSwagger = { ...response.data.result };
                    console.log('lambda',lambda)
                    modifiedSwagger.servers = [
                        {
                            url: `https://78slaf6rkh.execute-api.us-east-1.amazonaws.com/latest`,
                            description: "Custom Lambda API Gateway"
                        }
                    ];

                    setSwaggerData(modifiedSwagger);
                } else {
                    console.error("Invalid Swagger response format");
                }
            })
            .catch(error => console.error("Error fetching Swagger data:", error));
    }, []);
// const sampleSwagger = {
//     openapi: "3.0.0",
//     info: {
//         title: "Sample API",
//         description: "This is a sample Swagger API",
//         version: "1.0.0"
//     },
//     paths: {
//         "/users": {
//             get: {
//                 summary: "Get all users",
//                 responses: {
//                     "200": {
//                         description: "Successful response"
//                     }
//                 }
//             }
//         }
//     }
// };

    return (
        <div>
            {swaggerData ? <SwaggerUI spec={swaggerData}
              requestInterceptor={(req) => {
                console.log("Intercepting Request:", req);
                req.url = req.url.replace(window.location.origin, lambda);
                // Force Lambda URL
                return req;
            }} /> : <p>Loading Swagger Docs...</p>}
        </div>
    );
};

export default SwaggerComponent;
